import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import { createVuetify } from "vuetify";
import { aliases, mdi } from "vuetify/iconsets/mdi";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

export default createVuetify({
    components,
    directives,
    icons: {
        defaultSet: "mdi",
        aliases,
        sets: {
            mdi,
        },
    },
    theme: {
        themes: {
            light: {
                colors: {
                    primary: "#00796b",
                    secondary: "#7a4e8f",
                },
            },
            dark: {
                colors: {
                    primary: "#53b8ab",
                    secondary: "#b78fcb",
                },
            },
        },
    },
});
